import { PageEnum } from '@/enums/pageEnum';
import { navigateTo, updateTitle, navigateBack, redirectTo, getQuery, pack } from '@/utils/page';
import { debounce, throttle, getRandom } from './util';
import getServerTime from './getSeverTime';

export default {
    PageEnum,
    navigateTo,
    updateTitle,
    navigateBack,
    redirectTo,
    getQuery,
    pack,
    getRandom,
    debounce,
    throttle,
    getServerTime,
};
